// GENERATED FILE - DO NOT MODIFY DIRECTLY.
// Add countries to regions by modifying the CSV files in the "data/allowed-countries-by-region" directory.
// Then, to regenerate this file, run the create-region-dicts script.

export const ca = {
  CA: 'Canada',
};
